var _rect, _rect2, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgUpload = function SvgUpload(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 87 87"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 85,
    height: 85,
    x: 1,
    y: 1,
    fill: "#fff",
    rx: 42.5
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 85,
    height: 85,
    x: 1,
    y: 1,
    stroke: "#E6E6E6",
    rx: 42.5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#666060",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M52.25 44.507 43.5 36m0 0-8.75 8.507M43.5 36v21m-14-28h28"
  })));
};
export default SvgUpload;